/*
 * @Author: your name
 * @Date: 2021-12-09 22:52:16
 * @LastEditTime: 2022-03-22 16:41:12
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /download/src/main.ts
 */
import { Button, Icon, Image as VanImage, List, Popup, PullRefresh, Search, Tab, Tabs } from 'vant'
import Vue from 'vue'
import VueRouter from 'vue-router'

import { inMobile, isProduction } from './data/runtime'
import { logger, router, store } from './define'
import { executeTime } from './utils/Decorators'
// import { VSensors } from './utils/Directives'
import { initialRem } from './utils/initial-rem'
import { initialScaleAdapter } from './utils/initial-scale-adapter'
import App from './views/App.vue'

console.log('resources loaded')

/** 定义启动类 */
class Main {
    /** 主应用 */
    app!: any

    constructor() {
        this.setup()
    }

    /** 启动函数
     *
     * @description 耗时分析方法, 在非生产环境时, 均生效.
     */
    @executeTime('启动耗时')
    async setup(): Promise<void> {
        // ? vconsole 启用检查
        if (!isProduction && inMobile && !window.chrome) {
            const VConsole = await require('vconsole')
            new VConsole({ theme: 'dark' })
        }
        // > 初始化缩放比
        initialScaleAdapter()
        initialRem()
        // > 注入全局组件引用
        this.registerVuePrototypeRef()
        // > 注册实例
        this.app = new Vue({
            name: 'app',
            router,
            store,
            render: (h) => h(App)
        }).$mount('#app').$children[0]
    }

    /** 注册全局组件引用 */
    private async registerVuePrototypeRef() {
        logger.trace(process.env.NDOE_ENV)
        logger.trace('注册组件引用 - 开始')
        Vue.use(VueRouter)
        Vue.use(store)
        Vue.use(Popup)
        Vue.use(Tab)
        Vue.use(Tabs)
        Vue.use(Icon)
        Vue.use(Search)
        Vue.use(VanImage)
        Vue.use(List)
        Vue.use(PullRefresh)
        Vue.use(Button)

        // Vue.use(VSensors)
        logger.trace('注册组件引用 - 完成')
    }
}

export const main = new Main()
